import React from 'react'

const UploadResultIcon = () => {
  return (
    <svg
      width="80"
      height="68"
      viewBox="0 0 80 68"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect y="12" width="56" height="56" rx="28" fill="#EFF8F4" />
      <mask
        id="mask0_1197_64671"
        maskUnits="userSpaceOnUse"
        x="16"
        y="28"
        width="24"
        height="24"
      >
        <rect x="16" y="28" width="24" height="24" fill="#C4C4C4" />
      </mask>
      <g mask="url(#mask0_1197_64671)">
        <path
          d="M26.6 41.8L24.425 39.625C24.2417 39.4417 24.0167 39.35 23.75 39.35C23.4833 39.35 23.25 39.45 23.05 39.65C22.8667 39.8333 22.775 40.0667 22.775 40.35C22.775 40.6333 22.8667 40.8667 23.05 41.05L25.9 43.9C26.0833 44.0833 26.3167 44.175 26.6 44.175C26.8833 44.175 27.1167 44.0833 27.3 43.9L32.975 38.225C33.1583 38.0417 33.25 37.8167 33.25 37.55C33.25 37.2833 33.15 37.05 32.95 36.85C32.7667 36.6667 32.5333 36.575 32.25 36.575C31.9667 36.575 31.7333 36.6667 31.55 36.85L26.6 41.8ZM28 50C26.6167 50 25.3167 49.7373 24.1 49.212C22.8833 48.6873 21.825 47.975 20.925 47.075C20.025 46.175 19.3127 45.1167 18.788 43.9C18.2627 42.6833 18 41.3833 18 40C18 38.6167 18.2627 37.3167 18.788 36.1C19.3127 34.8833 20.025 33.825 20.925 32.925C21.825 32.025 22.8833 31.3123 24.1 30.787C25.3167 30.2623 26.6167 30 28 30C29.3833 30 30.6833 30.2623 31.9 30.787C33.1167 31.3123 34.175 32.025 35.075 32.925C35.975 33.825 36.6873 34.8833 37.212 36.1C37.7373 37.3167 38 38.6167 38 40C38 41.3833 37.7373 42.6833 37.212 43.9C36.6873 45.1167 35.975 46.175 35.075 47.075C34.175 47.975 33.1167 48.6873 31.9 49.212C30.6833 49.7373 29.3833 50 28 50Z"
          fill="#5DB594"
        />
      </g>
      <mask
        id="mask1_1197_64671"
        maskUnits="userSpaceOnUse"
        x="56"
        y="0"
        width="24"
        height="24"
      >
        <rect x="56" width="24" height="24" fill="#C4C4C4" />
      </mask>
      <g mask="url(#mask1_1197_64671)">
        <path
          d="M75 9L73.75 6.25L71 5L73.75 3.75L75 1L76.25 3.75L79 5L76.25 6.25L75 9ZM75 23L73.75 20.25L71 19L73.75 17.75L75 15L76.25 17.75L79 19L76.25 20.25L75 23ZM65 20L62.5 14.5L57 12L62.5 9.5L65 4L67.5 9.5L73 12L67.5 14.5L65 20ZM65 15.15L66 13L68.15 12L66 11L65 8.85L64 11L61.85 12L64 13L65 15.15Z"
          fill="#AEDACA"
        />
      </g>
    </svg>
  )
}

export default UploadResultIcon
